import './controls.scss';

type BoxProps = {
  children?: React.ReactNode;
};

export function Controls(props: BoxProps) {
  return <div className="controls">{props.children}</div>;
}
